import { Bar, BarChart, CartesianGrid, LabelList, Tooltip, XAxis, YAxis } from "recharts";
import { formatCompactCurrency, formatCurrency } from "@/lib/calculators";
import { REACTIVATION_MRR } from "./exampleData";
import {
  BORDER,
  CHART_POSITIVE_SEMI_MUTED,
  MUTED_FG,
  tooltipStyle,
  xAxisProps,
  yAxisProps,
} from "./chartTheme";
import MetricChartFrame from "./MetricChartFrame";

/**
 * Reactivation MRR by month — recurring revenue from customers who cancelled
 * before and came back. A gain (the app's positive green), small and occasional.
 */
const ReactivationMrrChart = () => (
  <MetricChartFrame
    caption="Reactivation MRR is small and occasional — $200 to $700 a month as former customers return. A healthy signal, but never the main growth driver."
    breakdown="No breakdown"
    active="6M"
  >
    <BarChart data={REACTIVATION_MRR} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={BORDER} vertical={false} />
      <XAxis dataKey="label" {...xAxisProps} />
      <YAxis tickFormatter={(v) => formatCompactCurrency(Number(v))} width={52} {...yAxisProps} />
      <Tooltip
        cursor={{ fill: "hsl(var(--muted) / 0.4)" }}
        contentStyle={tooltipStyle}
        formatter={(value: number) => [formatCurrency(value), "Reactivation MRR"]}
      />
      <Bar
        dataKey="value"
        fill={CHART_POSITIVE_SEMI_MUTED}
        radius={[4, 4, 0, 0]}
        isAnimationActive={false}
      >
        <LabelList
          dataKey="value"
          position="top"
          formatter={(v: number) => formatCompactCurrency(Number(v))}
          fontSize={11}
          fill={MUTED_FG}
        />
      </Bar>
    </BarChart>
  </MetricChartFrame>
);

export default ReactivationMrrChart;
